// internal
import { ResponseMeta } from '@app/typings/services/service.d';
import { DataBrand, FormCreateBrandData, roleData } from '@app/typings/services/brand';
import { UserData } from '@app/typings/services/user';

export const KEY_BRAND_FETCH = 'KEY_BRAND_FETCH';
export interface FetchData {
  type: typeof KEY_BRAND_FETCH;
  payload: {
    name: string;
  };
}

export const KEY_BRAND_SET_DATA = 'KEY_BRAND_SET_DATA';
export interface SetData {
  type: typeof KEY_BRAND_SET_DATA;
  payload: {
    meta: ResponseMeta;
    data: DataBrand[];
  };
}

export const KEY_BRAND_SELECT_ID = 'KEY_BRAND_SELECT_ID';
export interface SelectID {
  type: typeof KEY_BRAND_SELECT_ID;
  payload: {
    id: string;
    name?: string;
  };
}

export const KEY_BRAND_CREATE = 'KEY_BRAND_CREATE';
export interface CreateBrand {
  type: typeof KEY_BRAND_CREATE;
  payload: FormCreateBrandData;
}

export const KEY_BRAND_CREATE_SUCCESS = 'KEY_BRAND_CREATE_SUCCESS';
export interface CreateBrandSuccess {
  type: typeof KEY_BRAND_CREATE_SUCCESS;
}

export const KEY_BRAND_UPDATE = 'KEY_BRAND_UPDATE';
export interface UpdateBrand {
  type: typeof KEY_BRAND_UPDATE;
  payload: {
    data: FormCreateBrandData;
    isSameName: boolean;
  };
}

export const KEY_BRAND_FETCH_LISTROLES = 'KEY_BRAND_FETCH_LISTROLES';
export interface FetchListRolesBrand {
  type: typeof KEY_BRAND_FETCH_LISTROLES;
  payload: {
    offset: number;
    limit: number;
  };
}

export const KEY_BRAND_SET_LISTROLES = 'KEY_BRAND_SET_LISTROLES';
export interface SetListRolesBrand {
  type: typeof KEY_BRAND_SET_LISTROLES;
  payload: {
    data: roleData[];
    meta: ResponseMeta;
  };
}

export const KEY_BRAND_CREATE_ROLE = 'KEY_BRAND_CREATE_ROLE';
export interface CreateRoleBrand {
  type: typeof KEY_BRAND_CREATE_ROLE;
  payload: {
    roleName: string;
    permission: string[];
  };
}

export const KEY_BRAND_UPDATE_ROLE = 'KEY_BRAND_UPDATE_ROLE';
export interface UpdateRoleBrand {
  type: typeof KEY_BRAND_UPDATE_ROLE;
  payload: {
    roleName: string;
    permission: string[];
  };
}

export const KEY_BRAND_DELETE_ROLES = 'KEY_BRAND_DELETE_ROLES';
export interface DeleteRolesBrand {
  type: typeof KEY_BRAND_DELETE_ROLES;
  payload: {
    roleId: string[];
  };
}

export const KEY_BRAND_MANAGE_USER = 'KEY_BRAND_MANAGE_USER';
export interface ManageUserInBrand {
  type: typeof KEY_BRAND_MANAGE_USER;
  payload: {
    userId: string;
    roleId: string;
    file?: any;
  };
}

export const KEY_BRAND_DELETE_USER = 'KEY_BRAND_DELETE_USER';
export interface DeleteUserInBrand {
  type: typeof KEY_BRAND_DELETE_USER;
  payload: string[];
}

export const KEY_BRAND_FETCH_WITHID = 'KEY_BRAND_FETCH_WITHID';
export interface FetchBrandWithId {
  type: typeof KEY_BRAND_FETCH_WITHID;
  payload: string;
}

export const KEY_BRAND_SET_WITHID = 'KEY_BRAND_SET_WITHID';
export interface SetBrandWithId {
  type: typeof KEY_BRAND_SET_WITHID;
  payload: DataBrand;
}

export const KEY_BRAND_CLEAR_CURRENTNAME = 'KEY_BRAND_CLEAR_CURRENTNAME';
export interface ClearCurrentBrandName {
  type: typeof KEY_BRAND_CLEAR_CURRENTNAME;
}

export const KEY_BRAND_ROLE_WITHID = 'KEY_BRAND_ROLE_WITHID';
export interface BrandRoleWithId {
  type: typeof KEY_BRAND_ROLE_WITHID;
  payload: string;
}

export const KEY_BRAND_SET_CURRENTROLE = 'KEY_BRAND_SET_CURRENTROLE';
export interface BrandSetCurrentRole {
  type: typeof KEY_BRAND_SET_CURRENTROLE;
  payload: roleData;
}

export const KEY_BRAND_CLEAR_CURRENTROLE = 'KEY_BRAND_CLEAR_CURRENTROLE';
export interface BrandClearCurrentRole {
  type: typeof KEY_BRAND_CLEAR_CURRENTROLE;
}

export const KEY_BRAND_CREATEBY_FETCH = 'KEY_BRAND_CREATEBY_FETCH';
export interface BrandCreateByFetch {
  type: typeof KEY_BRAND_CREATEBY_FETCH;
}

export const KEY_BRAND_CREATEBY_SETDATA = 'KEY_BRAND_CREATEBY_SETDATA';
export interface BrandCreateBySetData {
  type: typeof KEY_BRAND_CREATEBY_SETDATA;
  payload: UserData;
}
export const KEY_BRAND_CREATEBY_CLEAR = 'KEY_BRAND_CREATEBY_CLEAR';
export interface BrandCreateByClear {
  type: typeof KEY_BRAND_CREATEBY_CLEAR;
}

export const KEY_BRAND_UPLOAD_PICTURE = 'KEY_BRAND_UPLOAD_PICTURE';
export interface BrandUploadPicture {
  type: typeof KEY_BRAND_UPLOAD_PICTURE;
  payload: {
    brandId: string;
    type: string;
    file: any;
  };
}

export type BrandType =
  | FetchData
  | SetData
  | SelectID
  | CreateBrand
  | CreateBrandSuccess
  | UpdateBrand
  | FetchListRolesBrand
  | SetListRolesBrand
  | CreateRoleBrand
  | UpdateRoleBrand
  | DeleteRolesBrand
  | ManageUserInBrand
  | DeleteUserInBrand
  | FetchBrandWithId
  | SetBrandWithId
  | ClearCurrentBrandName
  | BrandRoleWithId
  | BrandSetCurrentRole
  | BrandClearCurrentRole
  | BrandCreateByFetch
  | BrandCreateBySetData
  | BrandCreateByClear
  | BrandUploadPicture;
